// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#preview-pag[data-v-82f19406]{width:80vw;height:80vh;display:flex;align-items:center}.prev-image[data-v-82f19406]{max-width:80vw}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
